import { render, staticRenderFns } from "./appDescription.vue?vue&type=template&id=0191c3f1&scoped=true&"
import script from "./appDescription.vue?vue&type=script&lang=js&"
export * from "./appDescription.vue?vue&type=script&lang=js&"
import style0 from "./appDescription.vue?vue&type=style&index=0&id=0191c3f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0191c3f1",
  null
  
)

component.options.__file = "appDescription.vue"
export default component.exports